// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__U5OqW","tab":"Tabs_tab__DsW2m","active":"Tabs_active__Sw7PV"};